import Cursor from '@/components/common/cusor';
import Lines from '@/components/common/Lines';
import ProgressScroll from '@/components/common/ProgressScroll';
import Footer from '@/components/home-main/Footer';
import Navbar from '@/components/home-main/Navbar';
import Header from '@/pages/landingpage/services-pages/project1/components/Header';
import { Helmet } from 'react-helmet';
import ServiceIntro from './components/ServiceIntro';
import aiBg from '@/assets/images/AI-Background.webp';


export default function AIUnit() {
  return (
    <>
      <Helmet>
        <title>Artificial intelligence</title>
        <link rel="icon" href="/light/assets/imgs/fox.webp" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
 
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <main>
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header title='GCAD AI Services' bgImg={aiBg}/>
              {/* <Header title='GCAD AI Services' bgImg='https://static.wixstatic.com/media/d82902_2bc87224873a4b2398aac40689a73961~mv2.jpg'/> */}
              <ServiceIntro />
              {/* <Illustration /> */}
              {/* <Solution /> */}
            </main>
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
}
